




































































import { Component, Vue } from "vue-property-decorator";
import cq from "./components/cq.vue";
import cs from "./components/cs.vue";
import cq3 from "./components/cq3.vue";
@Component({
  components: { cq, cs, cq3 },
})
export default class Home extends Vue {
  public currentPage = 5;
  public active = 0;
  public pages: any = [cq, cs, cq3];
  public nowPage: any = cq;
  public tabList: any = [
    {
      title: "入款",
      bgImg: "/static/imgs/Authorization-icon1.png",
    },
    {
      title: "盖章",
      bgImg: "/static/imgs/Authorization-icon2.png",
    },
    {
      title: "开后台",
      bgImg: "/static/imgs/Authorization-icon3.png",
    },
    {
      title: "调整版本",
      bgImg: "/static/imgs/Authorization-icon4.png",
    },
    {
      title: "申请开区",
      bgImg: "/static/imgs/Authorization-icon5.png",
    },
    {
      title: "宣传",
      bgImg: "/static/imgs/Authorization-icon6.png",
    },
    {
      title: "管理游戏",
      bgImg: "/static/imgs/Authorization-icon7.png",
    },
  ];
  public handleChangeStatus(status) {
    this.active = status;
    this.nowPage = this.pages[status];
  }
}
